import { useEffect, useState } from "react";
import styled from 'styled-components'
import { Col, Container } from 'react-bootstrap'
import { Box, MainHeading, SpanStyled } from '../../../ui/Elements'
import { ArrowBtn, HeroBg, HeroBgAr, Instagram, LinkedIn, Twitter, Vision2030, Whatsapp, WhatsAppCtnt, WhatsIcon, WhatsIconBtn } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { ButtonWithIcon, ButtonWithIcon2, ContactButton, ContactButtonHref } from '../../../ui/CustomElements'
import i18n from '../../../Languages/INEXT'
const Banner = () => {
    const { t } = useTranslation();
      const [isMobile, setIsMobile] = useState(window.innerWidth < 420);

    const WhatsApp = () => {
        const phoneNumber = '+966506184384';
        const message = 'Hello, this is Tamkeen';
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };
    const socialIcon = [
        
        {
            img: <Twitter />,
            link: 'https://x.com/tamkeenxpo',
        },
        {
            img: <Instagram />,
            link: 'https://www.instagram.com/tamkeenxpo/',
        },
        /* {
            img: <Tiktok />,
            link: 'https://www.tiktok.com/',
        },
        {
            img: <SnapChat />,
            link: 'https://snapchat.com/',
        }, */
        /* {
            img: <LinkedIn />,
            link: 'https://www.linkedin.com/',
        }, */
    ]
    useEffect(() => {
        const handleResize = () => {
      setIsMobile(window.innerWidth < 420);
    };

    window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return (
        <>
            <BannerWapper className='container-fluid common-space bannerFluid'  id='home'>
                <Container>
                    <Box className='bannerRow row'>
                        <Col md={12} className="pb-5 bannerColMain">
                            <Box className='bannerContent'>
                                
                                <MainHeading className='main-heading main-heading-banner' size="" lh="1.1" color="var(--bg)">
                                    {/* {isMobile ? (
                                        {i18n.language === "ar" ? 
                                            <>
                                                {t('BannerHeading1')}<br></br>
                                                {t('BannerHeading2')}<br></br>
                                                {t('BannerHeading3')}
                                            </>
                                        : 
                                            <>
                                                {t('BannerHeading')}
                                            </>
                                        }
                                    ) : (
                                        {t('BannerHeading')}
                                    )} */}
                                    {isMobile ? (
                                        t('BannerHeading')
                                        
                                    ) : (
                                        i18n.language === "ar" ? (
                                        <>
                                            {t('BannerHeading1')}<br />
                                            {t('BannerHeading2')}<br />
                                            {t('BannerHeading3')}
                                        </>
                                        ) : (
                                        <>
                                            {t('BannerHeading')}
                                        </>
                                        )
                                    )}
                                </MainHeading>
                                <SpanStyled className='d-flex align-items-center gap-2 flex-sm-wrap'>
                                    <ContactButton icon={ArrowBtn} label={t('BookYourConsultation')} onClick={WhatsApp} />
                                    {/* <WhatsAppCtnt className='drWhatsBtn cursor-pointeer' onClick={WhatsApp} /> */}
                                    {/* <ButtonWithIcon2 className='drWhatsBtn cursor-pointeer' bg="#25D366" icon={WhatsIconBtn} label={t('whatsapp')} onClick={WhatsApp} /> */}
                                    
                                </SpanStyled>
                                
                            </Box>
                            <Box className='socialRowBanner'>
                                <Box className='Social-links'>
                                    {
                                        socialIcon.map((list, key) => (
                                            <a href={list.link} target="_blank" key={key} className='contact-links'>
                                                {list.img}
                                            </a>
                                        ))
                                    }
                                </Box>
                                <Box className='partnerLogo'>
                                    <img src={Vision2030} alt="vision" />
                                </Box>
                            </Box>

                        </Col>
                        
                    </Box>
                </Container>
            </BannerWapper>
        </>
    )
}
const BannerWapper = styled.section`
    padding-bottom: 2px;
    background-image: url(${HeroBg});
    background-size: cover;
    background-position: top center;
    /* height: 745px; */
    padding-top: 100px;
    & > .container{
        .bannerColMain{
            height: 675px;
            
            background-repeat: no-repeat;
            background-size: cover;
            background-position: left center;
            border-radius: 16px;
            overflow: hidden;
            .bannerContent{
                display: flex;
                width: 750px;
                flex-wrap: wrap;
                flex-direction: column;
                padding-top: 107px;
                padding-left: 110px;
                .main-heading-banner{
                    font-family: var(--familyRbtFlex);
                    font-weight: var(--semiBold);
                    font-size: 70px;
                    margin-bottom: 40px;
                }
                
                
            }
            .socialRowBanner{
                display: flex;
                width: 100%;
                justify-content: space-between;
                align-items: flex-end;
                padding: 60px 110px 0 110px;
                .Social-links{
                    display: flex;
                    gap: 20px;
                    width: fit-content
                }
            }
        }
        
    }
    .bannerRow{
        padding: 0px 0px 0 0px;
        align-items: center;
        /* margin-left: 0;
        margin-right: 0; */
    }
    .bannerImgContainer{
        padding-top: 20px;
    } 
    body.rtl &{
        & > .container{
            .bannerColMain{
                direction: ltr;
                /* background-image: url(${HeroBgAr});
                background-position: right center; */
                .bannerContent{
                    direction: rtl;
                    /* padding-top: 150px;
                    padding-left: 0;
                    padding-right: 168px; */
                    .main-heading-banner{
                        font-family: var(--arBold);
                        font-weight: var(--semiBold);
                        font-size: 64px;
                        margin-bottom: 40px;
                        line-height: 1.3;
                    }
                    
                }
            }
        }
            
        
        .bannerRow{
            padding: 0px 0px 0 0px;
            align-items: center;
            
        }
        
        .bannerCol1{
            padding-bottom: 60px !important;
        }
    }
    @media (max-width: 1399px) {
        .bannerRow{
            padding-left: 0;
            padding-right: 0;
        }
        body.rtl &{
            .bannerRow{
                padding: 0px 0px 0 0px;
                
            }
        }
    }
    @media (max-width: 1199px) {
        display: flex;
        align-items: center;
        padding-bottom: 0px;
        /* .main-heading{
            font-size: 55px;
        } */
    }
    @media (max-width: 991px) {
        padding-top: 84px;
        height: auto;
        /* .main-heading{
            font-size: 45px;
            text-align: center;
        } */
        .bannerSubTxt{
            font-size: 22px;
            text-align: center;
            margin-bottom: 30px;
        }
        .bannerSubDetailTxt{
            text-align: center;
            display: inline-block;
        }
        .bannerImgContainer{
            justify-content: center !important;
            padding-top: 0px;
        }
        .bannerCol1{
            padding-bottom: 30px !important;
        }
        .container{
            .bannerColMain{
                height: auto;
                .bannerContent{
                    padding: 50px 0 0 0;
                    width: 100%;
                    .main-heading-banner {
                        font-family: var(--familyRbtFlex);
                        font-weight: var(--semiBold);
                        font-size: 50px;
                        margin-bottom: 30px;
                    }
                }
                .socialRowBanner{
                    padding: 40px 0px 0 0px;
                    .Social-links{
                        display: flex;
                        gap: 20px;
                        width: fit-content
                    }
                }
            }
        }
        
        
        body.rtl &{
            
            .container{
                .bannerColMain{
                    
                    .bannerContent{
                        
                        .main-heading-banner {
                            font-size: 40px;
                            
                        }
                    }
                    
                }
            }
        }
    }
    @media (max-width: 767px) {
        & > .container{
            .bannerColMain{
                /* height: 440px; */
                /* background-size: 1190px 510px; */
                /* background-position: left -40px top -10px; */
                .bannerContent{
                    width: 100%;
                    /* padding-top: 50px; */
                    /* padding-left: 90px; */
                }
            }
        }
        body.rtl &{
            & > .container{
                .bannerColMain{
                    /* background-image: url(${HeroBgAr});
                    background-size: 1190px 510px;
                    background-position: right -120px top -10px; */
                    .bannerContent{
                        /* padding-top: 70px;
                        padding-right: 9px; */
                        
                    }
                }
            }
             
        }
    }
    @media (max-width: 640px) {
        padding-top: 80px;
        body.rtl &{
            .main-heading{
                font-size: 35px;
            }
            .bannerSubTxt{
                font-size: 24px;
            }
        }
    }
    @media (max-width: 575px) {
        & > .container{
            .bannerColMain{
                /* background-position: left -110px top -10px; */
                .bannerContent{
                    width: 100%;
                    /* padding-top: 50px;
                    padding-left: 10px;
                    padding-right: 10px; */
                }
                .socialRowBanner{
                    flex-wrap: wrap;
                    gap: 20px;
                }
            }
        }
    }

    @media (max-width: 480px) {
        
        
        
        body.rtl &{
            
            .container{
                .bannerColMain{
                    
                    .socialRowBanner{
                        justify-content: end;
                    }
                }
            }
        }
    }

    
    @media (max-width: 350px) {
        & > .container{
            .bannerColMain{
                .bannerContent{
                    padding-left: 0px;
                    padding-right: 0px;
                }
            }
        }
    }
`
export default Banner
